'use strict';

angular.module('shop').service('PaymentService', function ($q, $http) {
	var service = this;

	this.getCheckout = function(customerId, cart) {
		var host = location.protocol + '//' + location.host;

		var data = {
			customerID: customerId,
			payDirect: true,
			useLoyalty: false,
			checkout: host + '/shop/checkout/payment/?order_id={checkout.order.id}',
			confirmation: host + '/shop/checkout/confirmation/?order_id={checkout.order.id}'
		};

		if (cart.giftCode && cart.giftCode !== '') {
			data.giftCode = cart.giftCode;
		}

		return $http({
			url: '/backapi/ShopBeforeKCO',
			method: 'POST',
			data: data
		}).then(function(response) {
			if (!response || !response.data) return $q.reject('Klarna not available');

			return service.klarnaCheckout(response.data);
		});
	};

	this.completeCheckout = function(checkoutData) {
		return $http({
			url: '/backapi/MyPageAfterKCO',
			method: 'POST',
			data: checkoutData
		});
	};

	this.klarnaCheckout = function(checkoutData) {
		return $http({
			url: '/checkout/v3/orders',
			method: 'POST',
			data: checkoutData
		}).then(function(response) {
			if (!response || !response.data) return $q.reject('Klarna order not available');

			return response.data;
		});
	};

	this.klarnaSummary = function(orderId) {
		return $http({
			url: '/checkout/v3/orders/' + orderId,
			method: 'GET'
		}).then(function(response) {
			if (!response || !response.data) return $q.reject('Klarna order not available');

			return response.data;
		});
	};
});
